import type { GuardianEstado } from 'shared';

// How the backoffice shows an Encarregado de Educação and their educandos.

export const GUARDIAN_ESTADO_LABELS: Record<GuardianEstado, string> = {
  Pendente: 'Pendente',
  Ativo: 'Ativo',
  Inativo: 'Inativo',
};

/** The filter tabs, pending first: those are the ones waiting for someone. */
export const GUARDIAN_FILTERS: ReadonlyArray<{ estado: GuardianEstado | ''; label: string }> = [
  { estado: 'Pendente', label: 'Pendentes' },
  { estado: 'Ativo', label: 'Ativos' },
  { estado: 'Inativo', label: 'Inativos' },
  { estado: '', label: 'Todos' },
];

/** "YYYY-MM-DD…" as a day in pt-PT, with no time zone moving it. */
export function formatDay(iso: string): string {
  const day = iso.slice(0, 10);
  const date = new Date(`${day}T12:00:00Z`);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('pt-PT', { timeZone: 'UTC' });
}

/** Whole years from a date of birth to `today`. */
export function ageOn(dataNascimento: string, today: Date = new Date()): number | null {
  const [y, m, d] = dataNascimento.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return null;
  const beforeBirthday =
    today.getMonth() + 1 < m || (today.getMonth() + 1 === m && today.getDate() < d);
  return today.getFullYear() - y - (beforeBirthday ? 1 : 0);
}

/** "12/03/2014 · 12 anos" */
export function birthAndAge(dataNascimento: string, today: Date = new Date()): string {
  const age = ageOn(dataNascimento, today);
  const born = formatDay(dataNascimento);
  return age === null ? born : `${born} · ${age} ${age === 1 ? 'ano' : 'anos'}`;
}

/** What made a participant a suggestion, in words. */
export function matchedOnLabel(matchedOn: string): string {
  const parts = matchedOn.split(',').filter(Boolean);
  const words = parts.map((p) => (p === 'email' ? 'email' : p === 'telemovel' ? 'telemóvel' : p));
  if (words.length === 0) return '';
  return `O ${words.join(' e o ')} do EE no registo do participante coincide${words.length > 1 ? 'm' : ''}`;
}
